module.exports = __webpack_public_path__ + "static/media/TUNE_4871.f1a45126.jpg";